import * as React from "react";
import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FormControl, Slide } from "@mui/material";
import emailjs from "emailjs-com";
import { Form, Input, TextArea, Button } from "semantic-ui-react";
import Swal from "sweetalert2";
import { auth, getAuth, onAuthStateChanged } from "firebase/auth";

const SERVICE_ID = "dhproject1";
const TEMPLATE_ID = "template_inafc7l";
const PUBLIC_KEY = "GWhQ-YBtzZlmbESbK";

const EnquireForm = ({ language }) => {
  const [open, setOpen] = useState(false);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        SERVICE_ID,
        TEMPLATE_ID,
        e.target,
        PUBLIC_KEY,
        { name: e.target.name.value, email: e.target.email.value, message: e.target.message.value, phone: e.target.phone.value },
      )
      .then(
        (result) => {
          console.log(result.text);
          Swal.fire({
            icon: "success",
            title: "Message Sent Successfully",
          });
        },
        (error) => {
          console.log(error.text);
          Swal.fire({
            icon: "error",
            title: "Oops, something went wrong",
            text: error.text,
          });
        }
      );
    e.target.reset();
  };

  // const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe(); // Cleanup the listener when the component unmounts
  }, []);

  const handleClickOpen = () => {
    if (user) {
      setOpen(true);
    } else {
      setOpen(false);
      {language === 'en' && (
      alert("You need to LogIn first")
      )}
      {language === 'hi' && (
      alert("आपको पहले लॉगिन करने की आवश्यकता है।")
      )}
      console.log("Please login to continue");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="App">
    {language === 'en' && (
      <button
        onClick={handleClickOpen}
        className="rounded-3xl bg-orange-500 text-white text-sm hover:bg-orange-400 hover:scale-90 sm:hover:scale-90 md:hover:scale-90 ease-in duration-300 sm:px-3 md:px-4 md:py-2 px-3 py-1 scale-75 lg:scale-125 lg:mt-8 lg:px-4 lg:py-2 lg:hover:scale-150"
        type="button"
      >
        Enquire Now
      </button>
    )}
    {language === 'hi' && (
      <button
        onClick={handleClickOpen}
        className="rounded-3xl bg-orange-500 text-white text-sm hover:bg-orange-400 hover:scale-90 sm:hover:scale-90 md:hover:scale-90 ease-in duration-300 sm:px-3 md:px-4 md:py-2 px-3 py-1 scale-75 lg:scale-125 lg:mt-8 lg:px-4 lg:py-2 lg:hover:scale-150"
        type="button"
      >
        अभी पूछें
      </button>
    )}
      <Dialog
        open={open}
        onClose={handleClose}
        transitionDuration={700}
        TransitionComponent={Slide}
      >
        <div className="flex flex-row justify-between">
          <div className="pl-4"></div>
          <DialogTitle className="flex text-center">Send Enquiry</DialogTitle>
          <div className="pt-5 mr-4 scale-150 hover:opacity-70">
            <AiOutlineCloseCircle
              className="text-red-500"
              onClick={handleClose}
            />
          </div>
        </div>
        <DialogContent>
          <DialogContentText className="flex items-center justify-center">
            Write to us for any business enquiries
          </DialogContentText>
          <Form onSubmit={handleOnSubmit}>
            <Form.Field>
              <TextField
                margin="dense"
                id="name"
                label="Enter Name"
                type="text"
                fullWidth
                variant="outlined"
                required={true}
                name="from_name"
              />
            </Form.Field>
            <Form.Field>
              <TextField
                margin="dense"
                id="email"
                label="Enter Email"
                // type="tel"
                fullWidth
                variant="outlined"
                required={true}
                minLength={10}
                maxLength={10}
                // pattern="[0-9]{10}"
                name="reply_to"
              />
            </Form.Field>
            <Form.Field>
              <TextField
                margin="dense"
                id="phone"
                label="Enter Mobile"
                type="tel"
                fullWidth
                variant="outlined"
                required={true}
                minLength={10}
                maxLength={10}
                pattern="[0-9]{10}"
                name="mobile_no"
              />
            </Form.Field>
            <TextField
              margin="dense"
              id="message"
              label="Message"
              type="text"
              fullWidth
              variant="outlined"
              required={true}
              multiline={true}
              rows={4}
              maxLength={10}
              name="message"
            />
            <div className="flex justify-center mb-8 items-center mt-2">
              <button
                onClick={handleClose}
                className="rounded-3xl bg-orange-500 text-white md:px-64 px-10 sm:px-64 py-2 hover:bg-orange-400 hover:scale-105 ease-in duration-100"
                type="submit"
              >
                Submit
              </button>
            </div>
          </Form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EnquireForm;
